import React from 'react';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="comprar" className="bg-ink py-14 px-6 relative overflow-hidden" data-id="element-153">
      <div className="absolute -top-[100px] left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full bg-[radial-gradient(circle,rgba(92,122,101,0.2)_0%,transparent_60%)] pointer-events-none" data-id="element-154"></div>

      <span className="block text-center text-[10px] font-semibold tracking-[0.14em] uppercase text-gold mb-4" data-id="element-155">
        Acceso completo · Hoy
      </span>
      <h2 className="font-serif text-[30px] font-light italic text-white text-center mb-8 leading-[1.3]" data-id="element-156">
        Todo lo que necesitás saber
        <br data-id="element-157" />
        sobre tus hormonas
      </h2>

      <Reveal data-id="element-158">
        <div className="bg-white/5 border border-white/10 rounded-[20px] py-7 px-6 mb-5 relative z-10" data-id="element-159">
          <p className="text-[13px] text-white/35 line-through text-center mb-1" data-id="element-160">
            Valor regular: $39.990
          </p>
          <div className="text-center mb-5" data-id="element-161">
            <span className="text-[18px] font-light text-white/60 align-top mt-2 mr-0.5 inline-block" data-id="element-162">
              $
            </span>
            <span className="font-serif text-[64px] font-semibold text-white leading-none" data-id="element-163">
              24.990
            </span>
          </div>
          <p className="text-[12px] text-white/35 text-center mt-1" data-id="element-164">
            Pago único · Sin suscripción · Acceso de por vida
          </p>

          <div className="flex flex-col gap-2.5 mb-6 py-5 border-y border-white/10 mt-6" data-id="element-165">
            <div className="flex items-center gap-2.5 text-[13px] text-white/70" data-id="element-166">
              <span className="text-sage text-[14px] shrink-0" data-id="element-167">✓</span>
              Código Hormonal — Tomo principal (5 capítulos)
            </div>
            <div className="flex items-center gap-2.5 text-[13px] text-white/70" data-id="element-168">
              <span className="text-sage text-[14px] shrink-0" data-id="element-169">✓</span>
              Test de Perfil Hormonal interactivo — GRATIS
            </div>
            <div className="flex items-center gap-2.5 text-[13px] text-white/70" data-id="element-170">
              <span className="text-sage text-[14px] shrink-0" data-id="element-171">✓</span>
              Guía de Suplementos con Evidencia — BONO
            </div>
            <div className="flex items-center gap-2.5 text-[13px] text-white/70" data-id="element-172">
              <span className="text-sage text-[14px] shrink-0" data-id="element-173">✓</span>
              Descarga inmediata en PDF
            </div>
            <div className="flex items-center gap-2.5 text-[13px] text-white/70" data-id="element-174">
              <span className="text-sage text-[14px] shrink-0" data-id="element-175">✓</span>
              Compatible con celular, tablet y PC
            </div>
          </div>

          <a href="https://www.soportesaberdigital.com/cart/49527567057135:1" target="_blank" rel="noopener noreferrer" className="btn-buy flex items-center justify-center gap-2 w-full bg-gradient-to-br from-terra to-[#D4693F] text-white font-sans text-[16px] font-bold py-5 px-8 rounded-xl no-underline tracking-[0.01em] transition-all duration-150 relative overflow-hidden bg-[#9F2828]" data-id="element-176">
            <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" data-id="element-177"></div>
            Quiero acceso ahora — $24.990
          </a>
          <p className="text-center mt-3 text-[12px] text-white/30" data-id="element-178">
            Pago seguro · Recibís acceso de forma inmediata
          </p>

          <div className="bg-[#C9A84C]/10 border border-[#C9A84C]/20 rounded-lg py-3 px-4 mt-4 flex items-center gap-2.5" data-id="element-179">
            <span className="text-[16px]" data-id="element-180">⏳</span>
            <p className="text-[12px] text-gold leading-[1.4]" data-id="element-181">
              Precio de lanzamiento. Sin fecha de vencimiento confirmada.
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}